import React from 'react';
import { Card, Col, Row, Typography } from 'antd';
import PropTypes from 'prop-types';

import { Link } from 'components/layout';
import './style.less';

const { Text } = Typography;

const HeroButton = ({ icon, title, search, to }) => {
  return (
    <Link to={to} search={search}>
      <Card bordered={false} className="hero-btn">
        <Row>
          <Col span={24} className="hero-btn-icon-col">
            {icon}
          </Col>
          <Col span={24} className="hero-btn-title-col">
            <Text type="secondary">{title}</Text>
          </Col>
        </Row>
      </Card>
    </Link>
  );
};

HeroButton.propTypes = {
  icon: PropTypes.any.isRequired,
  title: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  search: PropTypes.string,
};

export default HeroButton;
